import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RequestHistoryComponent } from './request-history.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [RequestHistoryComponent],
    imports: [CommonModule, MatIconModule, MatButtonModule, TranslateModule],
    exports: [RequestHistoryComponent],
})
export class RequestHistoryModule {}
